import { Abruftoken } from '@/models/Abruftoken'
import { decodeJwt } from 'jose'

/**
 * Returns true if the abruftoken is expired.
 * @param abruftoken
 */
export function checkAbruftokenExpired(abruftoken: Abruftoken): boolean {
  const payload = decodeJwt(abruftoken.abruftoken)

  if (!payload.exp) {
    return false
  }

  const now = Math.floor(Date.now() / 1000)
  return now >= payload.exp
}
